<div class="iot-platform-ui-page-title-card" fxLayout="row" fxLayoutAlign="center center">
  <span class="iot-platform-ui-page-title-card__label fs-16 fw-700">{{ label()  | translate }}</span>
</div>
